import { useQuery, keepPreviousData } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { EventRow, Paginated } from "@/lib/types";

type EventStatus = "upcoming" | "past" | "draft" | "";

interface EventsQuery {
  search?: string;
  status?: EventStatus;
  page?: number;
  ordering?: string;
}

/** GET /api/v1/events/. */
export function useEvents(q: EventsQuery = {}) {
  return useQuery<Paginated<EventRow>>({
    queryKey: ["events", q],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (q.search)   params.set("search",   q.search);
      if (q.status)   params.set("status",   q.status);
      if (q.page)     params.set("page",     String(q.page));
      if (q.ordering) params.set("ordering", q.ordering);
      const { data } = await api.get<Paginated<EventRow>>(
        `/events/?${params.toString()}`,
      );
      return data;
    },
  });
}
